import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import AppComponent from './App.vue';
import router from './router/index';
import 'element-plus/dist/index.css';
import './styles/index.less';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { setupStore } from '@/store';
import { setupI18n } from './i18n';
import { customEvent } from './utils/utils';
import { handleInitVConsole } from '@/utils/handleVConsole';
import loadingDirective from '@/components/Loading/loading';
import customEventDirective from '@/components/CustomEventData/customEvent';
handleInitVConsole();

// 自动引入所有的 SVG 图标
const requireAll = function (requireContext) {
  return requireContext.keys().map(requireContext);
};
// @ts-ignore
const req = require.context('./assets/icons/svg', false, /\.svg$/);
requireAll(req);
const app = createApp(AppComponent);
app.config.globalProperties.$customEvent = customEvent;
app.directive('cusLoading', loadingDirective);
app.directive('customEvent', customEventDirective);
app.use(router);
app.use(ElementPlus);
setupStore(app);
setupI18n(app);
app.mount('#app');